const faqs = [
  {
    q: '青青草视频包含哪些平台的内容？',
    a: '青青草视频目前整合了妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频、菠萝视频、红杏视频等多个特色视频平台的资源，覆盖影视大全与热门视频合集，持续拓展更多优质平台接入。',
  },
  {
    q: '热门视频合集的更新频率是怎样的？',
    a: '热门视频合集每日精选更新，紧跟各平台最新发布动态。影视大全板块实时同步各平台热门内容，确保用户获得最新、最全的视频资源推荐。',
  },
  {
    q: '如何快速找到想看的视频内容？',
    a: '您可以通过首页的视频索引按平台分类浏览，或查看热门榜单了解当前热度最高的影视内容。精选推荐和专题精选模块也会每日推送优质热门视频合集。',
  },
  {
    q: '视频画质和播放体验如何？',
    a: '我们精选高清资源占比达99%，支持多种清晰度选择。不过需要说明的是，本站作为视频合集导航平台，实际播放体验取决于各合作平台的具体技术条件。',
  },
  {
    q: '是否需要注册账号才能使用？',
    a: '目前青青草视频无需注册即可浏览全部影视大全和热门视频合集内容。我们致力于提供简单便捷的视频内容发现体验，降低使用门槛。',
  },
  {
    q: '本站和各大视频平台是什么关系？',
    a: '青青草视频是一个独立的影视大全与热门视频合集导航聚合平台，与妖精视频、桃花视频、苹果视频、榴莲视频等平台无隶属关系。我们通过内容索引和推荐的方式帮助用户发现优质视频资源。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">常见问题</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              关于青青草视频及热门视频合集的常见疑问解答
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 flex items-start gap-3">
                  <span className="text-primary-500 font-bold flex-shrink-0">Q{i + 1}.</span>
                  <span>{faq.q}</span>
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed pl-7">
                  {faq.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}